import { faqItems } from '@/mocks/faq';

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于爆瓜网，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100/50 transition-colors list-none">
                <h3 className="text-sm font-bold text-foreground-900 pr-6">{item.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}